import { Component, OnDestroy, OnInit } from '@angular/core';
import { Table } from 'primeng/table';
import { GlobalConfigurationState } from '../state/global-configuration.state';
import { Store } from '@ngxs/store';
import { GenericIntegrationService } from '../service/generic-integration.service';
import { Subject, takeUntil } from 'rxjs';
import { ProductTypeModel, OrganizationModel } from './model/generic-mappers.model';

@Component({
	selector: 'cv-generic-mapper-dashboard',
	templateUrl: './generic-mapper-dashboard.component.html',
	styleUrls: ['./generic-mapper-dashboard.component.scss']
})
export class GenericMapperDashboardComponent implements OnInit, OnDestroy {
	private atComponentDestroy: Subject<any> = new Subject<any>();
	public integrations: Array<any> = [];
	public selectedIntegration: string = '';
	public selectedMapper: string = '';
	public mappers: Array<any> = [];
	public productTypeModel: any = ProductTypeModel;
	public organizationModel: any = OrganizationModel;

	constructor(
		private store: Store,
		private genericIntegrationService: GenericIntegrationService
	) {
	}

	ngOnInit(): void {
		this.integrations = this.store.selectSnapshot(GlobalConfigurationState.getGenericIntegrationsIdNameObjectType);

		if (this.integrations[0]) {
			this.selectedIntegration = this.integrations[0].id;
		}

		this.genericIntegrationService
			.getMappers(this.selectedIntegration)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(result => {
				this.mappers = result.map((mapper: any) => {
					return {
						id: mapper,
						name: mapper
					}
				});
				if (this.mappers[0]) {
					this.selectedMapper = this.mappers[0].id;
				}
			});
	}

	selectIntegration($event: any): void {
		console.log($event);
	}

	onSelectMapper($event: any): void {
		this.selectedMapper = null;
		this.selectedMapper = $event.value;
	}

	clear(table: Table) {
        table.clear();
    }

	filter(table: Table, $event: any): void {
		table.filterGlobal($event.target.value, 'contains');
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
